module.exports = __webpack_public_path__ + "img/amx-9.520de3ba.webp";